var path = 'widget/widgets-bundle-card.tpl.html';
var html = " <div class=tb-uppercase ng-if=\"item && parentCtl.types.id.nullUid === item.tenantId.id\" translate>widgets-bundle.system</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/widget/widgets-bundle-card.tpl.html
// module id = 1578
// module chunks = 1